import { barnToolsApi } from './base';
import { IAlarm, ISensor } from './types';

export const alarmApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['alarms'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllAlarms: builder.query<IAlarm[], void>({
        query: () => `alarms/`,
        providesTags: ['alarms'],
      }),
      getAlarmsBySensor: builder.query<IAlarm[], string>({
        query: (sensorId) => {
          return {
            url: `alarms/`,
            params: { sensorId },
          };
        },
        providesTags: ['alarms'],
      }),
      resolveAlarm: builder.mutation<
        { success: boolean; id: string; sensor: ISensor },
        string
      >({
        query: (id) => {
          return {
            url: `alarms/${id}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['alarms'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllAlarmsQuery,
  useGetAlarmsBySensorQuery,
  useResolveAlarmMutation,
} = alarmApi;
